// extracted by mini-css-extract-plugin
export default {"root":"DailyRevenue_root__bsXmU","overlay":"DailyRevenue_overlay__tmAuX"};